var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7933 1.33301H5.20668C2.78001 1.33301 1.33334 2.77967 1.33334 5.20634V10.7863C1.33334 13.2197 2.78001 14.6663 5.20668 14.6663H10.7867C13.2133 14.6663 14.66 13.2197 14.66 10.793V5.20634C14.6667 2.77967 13.22 1.33301 10.7933 1.33301ZM11.2133 7.21301C11.02 7.40634 10.7 7.40634 10.5067 7.21301L8.50001 5.20634V11.9997C8.50001 12.273 8.27334 12.4997 8.00001 12.4997C7.72668 12.4997 7.50001 12.273 7.50001 11.9997V5.20634L5.49334 7.21301C5.30001 7.40634 4.98001 7.40634 4.78668 7.21301C4.68668 7.11301 4.64001 6.98634 4.64001 6.85967C4.64001 6.73301 4.69334 6.59967 4.78668 6.50634L7.64668 3.64634C7.74001 3.55301 7.86668 3.49967 8.00001 3.49967C8.13334 3.49967 8.26001 3.55301 8.35334 3.64634L11.2133 6.50634C11.4067 6.69967 11.4067 7.01301 11.2133 7.21301Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUp);
export default __webpack_public_path__ + "static/media/sort-up.2d7227ffee6b55214e137eec4563b8b3.svg";
export { ForwardRef as ReactComponent };